var map = {
	"./24老师管理.svg": 7448,
	"./体育.svg": 9426,
	"./劳动实践.svg": 6475,
	"./地理.svg": 3784,
	"./学校办学质量.svg": 8823,
	"./学生.svg": 565,
	"./学生入口.svg": 8754,
	"./学生报名.svg": 1992,
	"./学生档案.svg": 4897,
	"./学生管理.svg": 4086,
	"./学生综合信息.svg": 2365,
	"./学生自评.svg": 3076,
	"./幼儿园管理.svg": 1618,
	"./教学.svg": 1022,
	"./教育.svg": 9422,
	"./机构.svg": 4079,
	"./生涯.svg": 2106,
	"./生物.svg": 7079,
	"./管理客户.svg": 9321,
	"./网络异常 (1).svg": 8825,
	"./网络异常.svg": 5022,
	"./老师管理.svg": 3771,
	"./选课.svg": 4721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2115;